const MuiFilledInput = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      backgroundColor: theme.palette.grey[200]
    })
  }
};
export default MuiFilledInput;